var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\" translate=\"MEMBER.MODAL.BOOKINGS_TABLE_CANCEL_BOOKING.TITLE\">\n</h3>\n</div>\n<form ng-submit=\"ok()\">\n<div class=\"modal-body\" style=\"min-height: 200px\">\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"booking.notify\"/>\n<span translate=\"MEMBER.MODAL.BOOKINGS_TABLE_CANCEL_BOOKING.EMAIL_CUSTOMER_CHECKBOX_LBL\"></span>\n</label>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button type=\"submit\" class=\"btn btn-primary\" translate=\"MEMBER.MODAL.BOOKINGS_TABLE_CANCEL_BOOKING.CANCEL_BOOKING_BTN\">\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"close($event)\" translate=\"MEMBER.MODAL.BOOKINGS_TABLE_CANCEL_BOOKING.CANCEL_BTN\"></button>\n</div>\n</form>\n";
var id1="core/_templates/bookings_table_cancel_booking.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/_templates/bookings_table_cancel_booking.html
// module id = 314
// module chunks = 0